<div class="modal-container">
  @if (inputData.title || inputData.closeButton) {
  <div class="modal-header">
    @if (inputData.title) {
    <div class="modal-title">
      @if (inputData.titleIcon) {
      <app-icon [icon]="$any(inputData.titleIcon)" size="3rem" color="--white" />
      }
      <span>{{ inputData.title }}</span>
    </div>
    }
    @if (inputData.closeButton) {
    <button class="modal-close-btn flex" type="button" aria-label="Cerrar" (click)="dialogRef.close()">
      <span class="material-icons">close</span>
    </button>
    }
  </div>
  }
  <div class="modal-content">
    <ng-container *ngComponentOutlet="inputData.component; inputs: inputData.inputs"></ng-container>
  </div>
</div>
